import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'boldText'
})
export class BoldTextPipe implements PipeTransform {

    transform(original: string, searchText: string, minimumLength: number = 1): string{
        if (!original)
            return '';

        original = this.sanitize(original);
        if (!searchText || searchText.length < minimumLength)
            return original;

        return original.replace(new RegExp(`(${this.escapeRegExp(searchText)})`, 'gi'), '<b>$1</b>');
    }

    sanitize(text: string) {
        return text.replace(/</gi, "&#60;").replace(/=/gi, "&#61;").replace(/>/gi, "&#62;")
    }

     escapeRegExp(text: string) {
      return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
    }

}
